import React, { useEffect } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import ContentLayout from "../../../../partials/content/ContentLayout";
import CrmDashboard from "./CrmDashboard";
import DirectSalesReport from "./DirectSalesReport";
import SalesCardReport from "./SalesCardReport";
import VisitSchedulesReport from "./VisitSchedulesReport";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import SalesPipelineReport from "./SalesPipelineReport";
import SalesmanPerformanceReport from "./SalesmanPerformanceReport";
function CrmReport({ history }) {
  const { reload } = useGlobalData();
  useEffect(() => {}, [reload]);
  return (
    <React.Fragment>
      <PageSubHeader
        title="CRM Reports"
        breadcrumbs={[
          { page: "/reports", title: "Reports", active: false },
          {
            page: "/crm/crm-reports",
            title: "CRM Reports",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/reports");
            },
          },
        ]}
      />
      <ContentLayout>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="tabview">
              <div className="card">
                <TabView
                  className="tabview"
                  renderActiveOnly={false}
                  scrollable
                >
                  <TabPanel
                    header="CRM Dashboard"
                    rightIcon="fas fa-chart-area"
                  >
                    <CrmDashboard />
                  </TabPanel>
                  <TabPanel
                    header="Sales Pipeline"
                    rightIcon="fas fa-funnel-dollar"
                  >
                    <SalesPipelineReport />
                  </TabPanel>
                  <TabPanel
                    header="Salesman Performance"
                    rightIcon="fas fa-tachometer-alt"
                  >
                    <SalesmanPerformanceReport />
                  </TabPanel>
                  <TabPanel header="Sales Card" rightIcon="fas fa-address-card">
                    <SalesCardReport />
                  </TabPanel>
                  <TabPanel header="Visit Schedule" rightIcon="fas fa-route">
                    <VisitSchedulesReport />
                  </TabPanel>
                  <TabPanel
                    header="Direct Sales"
                    rightIcon="fas fa-people-carry"
                  >
                    <DirectSalesReport />
                  </TabPanel>
                </TabView>
              </div>
            </div>
          </div>
        </div>
      </ContentLayout>
    </React.Fragment>
  );
}

export default CrmReport;
